// src/pages/admin/MissingConversionsPage.tsx
import React, { useEffect, useState } from 'react';
import fetchWithAuth from '../../utils/fetchWithAuth';

type Catalog = {
  id: number;
  nameCanonical: string;
  unitDefault: string | null;
};

export default function MissingConversionsPage() {
  const [items, setItems] = useState<Catalog[]>([]);
  const [inputs, setInputs] = useState<Record<number, { unitId: string; grams: number }>>({});

  useEffect(() => {
    fetchWithAuth('/api/admin/ingredients/missing-conversion').then(setItems);
  }, []);

  const handleCreate = async (catalogId: number) => {
    const { unitId, grams } = inputs[catalogId] || {};
    if (!unitId || !grams) return;
    await fetchWithAuth('/api/admin/ingredients/conversion', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ catalogId, unitId, gramsPerUnit: grams }),
    });
    setItems((cur) => cur.filter((i) => i.id !== catalogId));
  };

  return (
    <>
      <h1 className="text-xl font-bold mb-4">Missing Unit Conversions</h1>
      <table className="w-full table-auto border-collapse">
        <thead>
          <tr>
            <th className="border p-2">Ingredient</th>
            <th className="border p-2">Default Unit</th>
            <th className="border p-2">Unit ID</th>
            <th className="border p-2">Grams / Unit</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((i) => (
            <tr key={i.id}>
              <td className="border p-2">{i.nameCanonical}</td>
              <td className="border p-2">{i.unitDefault || '-'}</td>
              <td className="border p-2">
                <input
                  value={inputs[i.id]?.unitId || ''}
                  onChange={(e) =>
                    setInputs((s) => ({
                      ...s,
                      [i.id]: { ...(s[i.id] || {}), unitId: e.target.value },
                    }))
                  }
                  className="w-full p-1 border rounded"
                />
              </td>
              <td className="border p-2">
                <input
                  type="number"
                  value={inputs[i.id]?.grams || ''}
                  onChange={(e) =>
                    setInputs((s) => ({
                      ...s,
                      [i.id]: { ...(s[i.id] || {}), grams: +e.target.value },
                    }))
                  }
                  className="w-full p-1 border rounded"
                />
              </td>
              <td className="border p-2">
                <button
                  onClick={() => handleCreate(i.id)}
                  className="px-3 py-1 bg-green-600 text-white rounded"
                >
                  Create
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
